<template>
  <div>
    <div style="display: flex; align-items: center; margin-bottom: 20px; margin-top: 10px; width: 100%;">
      <div style="display: flex; align-items: center; flex-grow: 1;">
        <el-button size="small" type="success" icon="el-icon-plus" @click="handleEdit()">添加</el-button>
        <el-button size="small" type="danger" v-if="['ADMIN','MANAGER','SALES_ASSI_MANAGER'].includes(role)" icon="el-icon-delete" @click="handleDelete()">批量删除</el-button>
      </div>
      <export-components v-if="['ADMIN','MANAGER'].includes(role)" :apiFunction="exportGroup" :requestData="getSearch({})" :option="option" @sendData=getSearchData></export-components>
    </div>
    <div style="color:red;font-size: 16px;font-weight: bold;margin-bottom: 20px">注：创建课题组的时候会检查：手机号/邮箱的唯一性，即创建的手机号/邮箱会检查数据库内是否有一样的</div>
    <div style="width:100%;">
      <w-table :columns="columns" :table-data="tableData" @rowSelection="rowSelection"
               @getTableSearchSortCon="getTableSearchSortCon" :isPagination="true"
               :table-col-check="{isShow:true,name:'Customer-_Group2'}" ref="wMyTable"
               :page="page" @pageChange="handlePagePagination" :isShowRowSelection="true">
        <div slot="operation" slot-scope="{text,record}">
          <el-button size="mini" type="primary" v-if="['ADMIN','MANAGER','SALES_ASSI_MANAGER'].includes(role)" @click="handleEdit(record)">编辑</el-button>
          <el-button size="mini" type="danger" v-if="['ADMIN','MANAGER','SALES_ASSI_MANAGER'].includes(role)" @click="handleDelete(record)">删除</el-button>
        </div>
      </w-table>
      <add-customer-group v-if="showAddEditCusDialog" :show-dialog="showAddEditCusDialog" :selectType="selectType"
                         :select-detail="selectDetail" @submit="closeAddEditCusDialog">
      </add-customer-group>
      <picture-loading v-if="loading"></picture-loading>
    </div>

  </div>
</template>

<script>
import {getGroupPage,deletegroup} from "@/api/dilivery/customer/researchGroup";
import {customerGroup} from "@/utils/data/tableCol/customer/customerGroup";
import AddCustomerGroup from "@/components/customer/AddCustomerGroup";
import TableHeadNote from "@/components/customerTable/TableHeadNote.vue";
import {getDataInLocalStorage} from "@/utils/localStorage";
import {exportGroup} from "@/api/dilivery/export";
import PictureLoading from "@/components/customerTable/PictureLoading.vue";
import ExportComponents from "@/components/ExportComponents.vue";

export default {
  name: "Group",
  components: { ExportComponents, PictureLoading, TableHeadNote, AddCustomerGroup},
  data() {
    return {
      isShow:false,
      ids: [],
      role: '',
      loading: true, //是显示加载
      searchConditionTag: [],//搜索tag
      sortConditionTag: [],
      tableData: [],
      selectable: [],
      showAddEditCusDialog: false, //控制编辑页面显示与隐藏
      selectDetail: '',
      selectType: {},
      page: {
        pageSize: 10,
        currentNum: 1,
        total: null
      },
      option: [
        {label: '创建时间', value: 'createTime'},
      ],
      deleterInfo: {},
      showDeleteDialog: false,
    }
  },
  computed: {
    columns() {
      return JSON.parse(JSON.stringify(customerGroup(this.searchConditionTag || {})))
    }
  },
  created() {
    this.role = getDataInLocalStorage('role')
  },
  mounted() {
    this.getData()
  },
  methods: {
    exportGroup,
    //表格的选择框
    rowSelection(selectedRows) {
      this.ids = selectedRows.map(item => item.id)
      this.selectable = [...selectedRows]
    },
    getTableSearchSortCon(searchConditionTag, sortConditionTag) {
      this.searchConditionTag = searchConditionTag
      this.sortConditionTag = sortConditionTag
      this.getData('search')
    },
    getSearchData(sendData) {
      if (sendData) {
        this.searchConditionTag = this.searchConditionTag.filter(item => !this.option.map(itemA => itemA.value).includes(item.key))
        if (Object.keys(sendData).length) {
          this.searchConditionTag.push(sendData)
        }
        this.$refs.wMyTable.searchConditionTag = this.searchConditionTag;
        this.getData('search')
      }
    },
    // 获取数据
    getData(type) {
      this.loading = true
      let params = {
        'page.current': this.page.currentNum,
        'page.size': this.page.pageSize,
      }
      if (type) {
        this.sortConditionTag.forEach(item => {
          params["order"] = item.colName + "." + item.order
        })
        params['page.current'] = 1
        params['page.size'] = 10
      }
      let sendData = {}
      sendData = this.getSearch(sendData)
      getGroupPage(params, sendData).then(res => {
        this.loading = false
        if (res.code === 200) {
          this.tableData = res.data.records
          this.page.currentNum = parseInt(res.data.current)
          this.page.pageSize = parseInt(res.data.size)
          this.page.total = parseInt(res.data.total)
        }
      }).catch(() => {
        this.loading = false
      })
    },
    getSearch(sendData) {
      this.searchConditionTag.forEach(item => {
        if (this.option.map(it => it.value).includes(item.key)) {
          sendData["query#" + item.key + ".BETWEEN"] = item.value
        } else {
          sendData["query#" + item.key + ".LIKE"] = item.value
        }
      })
      return sendData
    },
    //页码的变动
    handlePagePagination(page) {
      this.page.currentNum = page.currentNum
      this.page.pageSize = page.pageSize
      this.getData()
    },
    //删除
    handleDelete(row) {
      let ids = []
      if (row && row.id) {
        ids.push(row.id)
      } else {
        if (this.ids.length > 0) {
          ids = this.ids
        } else {
          this.$messageUi.error('请勾选要批量删除的数据')
          return
        }
      }
      this.$confirmUi('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 删除
        let param = {
          "ids" : ids.join(',')
        }
        deletegroup(param).then(res => {
          if (res.code === 200) {
            this.$messageUi({
              type: 'success',
              message: '删除成功!'
            })
            this.ids = []
            const totalPage = Math.ceil((this.page.total - 1) / this.page.pageSize)
            this.page.currentNum = this.page.currentNum > totalPage ? totalPage : this.page.currentNum
            this.page.currentNum = this.page.currentNum < 1 ? 1 : this.page.currentNum
            this.getData()
          }
        }).catch(err => {
        })
      }).catch(() => {})
    },
    //编辑
    handleEdit(row) {
      if (row !== undefined && row !== 'undefined') {
        this.selectDetail = row
        this.selectType = {
          type: 'edit'
        }
      } else {
        this.selectType = {
          type: 'add'
        }
        this.selectDetail = ''
      }
      this.showAddEditCusDialog = true
    },
    // 关闭编辑、增加、批量添加弹出框
    closeAddEditCusDialog(type) {
      if (type === 'confirm') {
        this.getData()
      }
      this.$nextTick(() => {
        this.showAddEditCusDialog = false
      });
    },
  }
}
</script>

<style scoped>

</style>
